import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import FAQHeading from './FAQHeading'
import FAQBody from './FAQBody'

const FAQSection = ({
  tabIndex,
  name,
  headingStyle,
  iconSrc,
  toggleClassName,
  createUserEvent,
  category,
  action,
  target,
  bodyStyle,
  children
}) => {
  return (
    <Fragment>
      <FAQHeading
        tabIndex={tabIndex}
        headingStyle={headingStyle}
        toggleClassName={toggleClassName}
        name={name}
        iconSrc={iconSrc}
      />
      <FAQBody
        createUserEvent={createUserEvent}
        category={category}
        action={action}
        target={target}
        bodyStyle={bodyStyle}
      >
        {children}
      </FAQBody>
    </Fragment>
  )
}

FAQSection.propTypes = {
  tabIndex: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  headingStyle: PropTypes.object,
  iconSrc: PropTypes.string,
  toggleClassName: PropTypes.string,
  createUserEvent: PropTypes.func.isRequired,
  category: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  target: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  bodyStyle: PropTypes.object,
  children: PropTypes.node
}

export default FAQSection



// WEBPACK FOOTER //
// ./src/components/FAQ/FAQSection.js